import customAxios from "config";
import { globalJson } from "global/global_json";
import { renterError } from "utils/errorMessage";

export const getCompanyInfoFun = async (): Promise<any> => {
  try {
    const response = await customAxios.get("/api/company/configurations/", {
      params: {
        company_id:  process.env.REACT_APP_ENV !== "prod"
            ? globalJson.dev_company_id
            : globalJson.prod_company_id,
      },
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "company") };
  }
};
